import { createFileRoute } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import Projects from 'pages/Projects'
import ProjectsClassic from 'pages/Projects/Projects.classic'

const IS_CLASSIC_UI = getUIVersion() === 'classic'

export const Route = createFileRoute('/_auth/projects/')({
  component: IS_CLASSIC_UI ? ProjectsClassic : Projects,
})
